export default {
	decodeURIComponent:function(str){
		return decodeURIComponent(str);
	},
	encodeURIComponent:function(str){
		return encodeURIComponent(str);
	}
};
